// @flow weak

import moment               from 'moment';
import { appConfig }        from '../../config';
import {
  login,
  getAuthStatus,
  logoutApi
}                           from '../../services/API';

const REQUEST_USER_LOGIN   = 'REQUEST_USER_LOGIN';
const REQUEST_USER_LOGOUT   = 'REQUEST_USER_LOGOUT';
const RECEIVED_USER_LOGIN  = 'RECEIVED_USER_LOGIN';
const ERROR_USER_LOGIN     = 'ERROR_USER_LOGIN';
const REQUEST_AUTH_STATUS   = 'REQUEST_AUTH_STATUS';
const RECEIVED_AUTH_STATUS  = 'RECEIVED_AUTH_STATUS';
const ERROR_AUTH_STATUS     = 'ERROR_AUTH_STATUS';

type UserData = {
  login:            ?string,
  firstname:        string,
  lastname:         string,
  picture:          ?string,
  error_message:    ?string,
  isAuthenticated:  boolean,
  // whether the /auth/auth_status check has completed at least once --
  // gates the login-redirect render in App.js until we know the real
  // session state instead of flashing/redirecting on a guess.
  authChecked:      boolean
};

type UserInfoState = {
  isFetching:   boolean,
  data:         UserData,
  isConnected:  boolean,
  time:         ?string
};



const initialState: UserInfoState = {
  isFetching: false,
  data: {
    login:            null,
    firstname:        '',
    lastname:         '',
    picture:          null,
    error_message:    null,
    // login state is now confirmed via GET /auth/auth_status (see
    // checkAuthStatus() below), not a localStorage flag.
    isAuthenticated:  false,
    authChecked:      false
  },
  isConnected: false,
  time: null
};

export default function user(
  state: UserInfoState = initialState,
  action: any
) {
  switch (action.type) {

  case 'REQUEST_USER_LOGIN':
    return {
      ...state,
      isFetching: action.isFetching,
      time:       action.time
    };

  case 'RECEIVED_USER_LOGIN':
    return {
      ...state,
      isFetching: action.isFetching,
      data:       { ...action.data },
      isConnected: true, // set user connected when retreiving userInfos
      time:       action.time
    };

  case 'ERROR_USER_LOGIN':
    return {
      ...state,
      isFetching: action.isFetching,
      time:       action.time
    };

  case 'REQUEST_USER_LOGOUT':
    return {
      ...state,
      data:       { ...action.data },
      time:       action.time
    };

  case 'REQUEST_AUTH_STATUS':
    return {
      ...state,
      isFetching: action.isFetching,
      time:       action.time
    };

  case 'RECEIVED_AUTH_STATUS':
    return {
      ...state,
      isFetching: action.isFetching,
      data:       { ...state.data, isAuthenticated: action.isAuthenticated, authChecked: true },
      isConnected: action.isAuthenticated,
      time:       action.time
    };

  case 'ERROR_AUTH_STATUS':
    return {
      ...state,
      isFetching: action.isFetching,
      data:       { ...state.data, isAuthenticated: false, authChecked: true },
      time:       action.time
    };

  default:
    return state;
  }
}


export function loginUser(user_name,password) {
  return (
    dispatch: (action: any) => any,
    getState: () => any
  ) => {
    if (shouldFetchUserLogin(getState())) {
      return dispatch(fetchUserLogin(user_name,password));
    }
    return false;
  };
}

export function logoutUser() {
  return (
    dispatch: (action: any) => any,
    getState: () => any
  ) => {
    // Invalidate the session on the backend; clear local state regardless
    // of whether the request succeeds.
    return logoutApi()
      .catch(() => null)
      .then(() => dispatch(requestLogout()));
  };
}

export function checkAuthStatus() {
  return (
    dispatch: (action: any) => any,
    getState: () => any
  ) => {
    dispatch(requestAuthStatus());
    return getAuthStatus()
      .then(response => {
        const isAuthenticated = !!(response && response.success && response.logged_in);
        dispatch(receivedAuthStatus(isAuthenticated));
      })
      .catch(() => dispatch(errorAuthStatus()));
  };
}



function requestLogout(time: string = moment().format()) {
  return {
    type:       REQUEST_USER_LOGOUT,
    data: {isAuthenticated: false, authChecked: true},
    isFetching: true,
    time
  };
}

function requestAuthStatus(time: string = moment().format()) {
  return {
    type:       REQUEST_AUTH_STATUS,
    isFetching: true,
    time
  };
}

function receivedAuthStatus(isAuthenticated: boolean, time: string = moment().format()) {
  return {
    type:       RECEIVED_AUTH_STATUS,
    isFetching: false,
    isAuthenticated,
    time
  };
}

function errorAuthStatus(time: string = moment().format()) {
  return {
    type:       ERROR_AUTH_STATUS,
    isFetching: false,
    time
  };
}


function requestUserLogin(time: string = moment().format()) {
  return {
    type:       REQUEST_USER_LOGIN,
    isFetching: true,
    time
  };
}
function receivedUserLogin(data, time = moment().format()) {
  console.log( "receivedUserLogin:");
  console.log(data);
  if(!data['isAuthenticated']){
    // `data` is either the parsed JSON body (login() resolved normally) or
    // the Error thrown by checkStatus() for a non-2xx response (login()
    // catches it and resolves with the Error itself) -- `.message` carries
    // the backend's message/detail (incl. rate-limit/backoff text) either way.
    data['error_message'] = data['message'] || "Invalid Credentials"
  }
  return {
    type:       RECEIVED_USER_LOGIN,
    isFetching: false,
    data: data,
    time
  };
}
function errorUserLogin(time = moment().format()) {
  return {
    type:       ERROR_USER_LOGIN,
    isFetching: false,
    time
  };
}

function fetchUserLogin(user_name,password) {
  return dispatch => {
    dispatch(requestUserLogin(name));
      login(user_name,password)
        .then(
          data => dispatch(receivedUserLogin(data))
        )
        .catch(
          error => dispatch(errorUserLogin(error))
        );
  };  
}
function shouldFetchUserLogin(state) {
  const userInfosStore = state.userInfos;
  if (userInfosStore.isFetching) {
    return false;
  } else {
    return true;
  }
}



// WEBPACK FOOTER //
// ./src/app/redux/modules/user.js